<!-- Modal Header -->
<div class="modal-header">
  <h4 class="modal-title">{{title}}</h4>
</div>
<!-- Modal body -->
<div class="modal-body status-confirmation-popup">
  <div class="modal-body-inner">
    <div class="change-status-note">
      <h3 class="confirmation-text">{{message}}</h3>
    </div>
    <ng-container *ngIf="this.currentStatusId === constants.SAMPLE_PACKAGES_STATUS_ID">
      <form [formGroup]="samplePackingBoxForm" (ngSubmit)="onSubmitSampleBox()"
      (keydown.enter)="$event.preventDefault()">
        <div class="col" style="margin-top: 14px;">
          <div class="setting-form-field expiry-day-field">
            <label class="grey-label">
              Select Sample Packing Box <span class="text-danger">*</span>
            </label>
            <ng-select
            formControlName="sample_packing_box_id"
            [items]="samplePackingBox"
            [ngClass]="{
              'is-invalid': samplePackingBoxForm.controls['sample_packing_box_id']?.invalid &&
                            (samplePackingBoxForm.controls['sample_packing_box_id']?.dirty ||
                            samplePackingBoxForm.controls['sample_packing_box_id']?.touched ||
                            samplePackingSubmitted) ||
                            sbf.sample_packing_box_id?.errors?.apiError,
              'is-valid': !samplePackingBoxForm.controls['sample_packing_box_id']?.invalid
            }"
            [virtualScroll]="true"
            bindLabel="name"
            bindValue="id"
            [(ngModel)]="selectedSampleBox"
            placeholder="Select sample packing box"
            [clearable]="!!samplePackingBoxForm.controls['sample_packing_box_id'].value"
            (change)="onSampleBoxChange($event)"
            (clear)="onSampleBoxClear()"
          >
            <ng-template ng-option-tmp let-item="item">
              <div>
               {{ item.name }}<strong> ({{item.ul_code}})</strong>
              </div>
            </ng-template>
          </ng-select>

            <div
              *ngIf="samplePackingBoxForm.controls['sample_packing_box_id'].invalid && (samplePackingBoxForm.controls['sample_packing_box_id'].touched || samplePackingSubmitted)"
              class="invalid-feedback"
              role="alert"
            >
              <span *ngIf="samplePackingBoxForm.controls['sample_packing_box_id'].errors?.required">
                Select sample packing box.
              </span>
              <span *ngIf="samplePackingBoxForm.controls['sample_packing_box_id'].errors?.apiError">
                {{ samplePackingBoxForm.controls['sample_packing_box_id'].errors?.apiError }}
              </span>
            </div>
          </div>
        </div>
     <div class="form-group" style="padding: 0 15px !important">
        <label class="grey-label">Price (inc. GST) <span class="text-danger">*</span></label>
        <div class="input-group mt-2 price-input-group">
          <div class="input-group-prepend">
            <span class="input-group-text" id="basic-addon1">$</span>
          </div>
          <input
            class="form-control"
            [ngClass]="{
              'is-invalid': sbf.custom_packing_box_price.invalid && (sbf.custom_packing_box_price.dirty || sbf.custom_packing_box_price.touched || samplePackingSubmitted),
              'is-valid': !sbf.custom_packing_box_price.invalid && (sbf.custom_packing_box_price.dirty || sbf.custom_packing_box_price.touched || samplePackingSubmitted)
            }"
            formControlName="custom_packing_box_price"
            type="text"
            placeholder="Enter price"
            [disabled]="!isCustomOptionSelected"
            (keypress)="checkDecimalDot($event)" appDecimalInput
          >
          <span class="invalid-feedback" role="alert"
            *ngIf="sbf.custom_packing_box_price.invalid &&
                   (sbf.custom_packing_box_price.dirty ||
                    sbf.custom_packing_box_price.touched ||
                    samplePackingSubmitted)">
            <span *ngIf="sbf.custom_packing_box_price.errors?.required">
              Enter price.
            </span>
            <span *ngIf="samplePackingBoxForm.controls['custom_packing_box_price'].errors?.apiError">
              {{samplePackingBoxForm.controls['custom_packing_box_price'].errors?.apiError}}
            </span>
          </span>
        </div>
      </div>
        <div *ngIf="isCustomOptionSelected"  class="col" style="margin-top: -10px;">
          <label class="grey-label">Description <span class="required-field">*</span></label>
          <textarea class="form-control" rows="4" cols="4"
              [ngClass]="{ 'is-invalid': (samplePackingBoxForm.controls['custom_packing_box_description'].invalid && samplePackingBoxForm.controls['custom_packing_box_description'].touched || samplePackingSubmitted) || sbf.custom_packing_box_description.errors?.apiError, 'is-valid' : !(samplePackingBoxForm.controls['custom_packing_box_description'].invalid)}"
              formControlName="custom_packing_box_description"  placeholder="Enter description">
              </textarea>
          <span class="invalid-feedback" role="alert"
              *ngIf="(samplePackingBoxForm.controls['custom_packing_box_description'].invalid && samplePackingBoxForm.controls['custom_packing_box_description'].touched || samplePackingSubmitted) || sbf.custom_packing_box_description.errors?.apiError">
              <span *ngIf="sbf.custom_packing_box_description.errors?.required">Enter description.</span>
          </span>
        </div>
        <div class="modal-footer sample-package">
       <button type="button" class="dark-bordered-btn" data-dismiss="modal" (click)="decline()">Cancel</button>
       <button type="submit" class="submit-btn-grey create-user-btn">Confirm</button>
      </div>
     </form>
    </ng-container>
    <ng-container *ngIf="deliveryChargeRequired">
      <div class="delivery-charge-container">
        <form ngbAutofocus [formGroup]="shippingPriceForm" (ngSubmit)="onSubmit()"
              (keydown.enter)="$event.preventDefault()">
          <div class="dispatch-detail-inner form-title-main">
            <h4 class="form-title">Despatched Details</h4>
            <div class="form-field form-group bigpost-logistic-type"
                 [ngClass]="{ 'is-invalid bigpost-logistic-type-custom': sf.logistic_type_id.invalid && (sf.logistic_type_id.dirty || sf.logistic_type_id.touched ||submitted)}">
              <label class="confirmation-text delivery-charge-label">Logistic Type:</label>
              <div class="custome-radio">
                <div class="payment-mod-class"
                     *ngFor="let logisticType of logisticTypes; let i = index">
                  <input type="radio" id="option{{i}}" value="{{logisticType.id}}"
                         [attr.name]="logistic_type_id" formControlName="logistic_type_id"
                         (click)="setLogisticType(logisticType.id)">
                  <label for="option{{i}}">
                    {{logisticType.name}}
                  </label>
                </div>
              </div>
              <span role="alert"
                    *ngIf="sf.logistic_type_id.invalid && (sf.logistic_type_id.dirty || sf.logistic_type_id.touched ||submitted)">
                                <span class="error-logistic-type"
                                      *ngIf="sf.logistic_type_id.errors!== null && sf.logistic_type_id.errors.required">Select the logistic type.
                                </span>
                            </span>
                 </div>
                <div class="form-field form-group" *ngIf="!hideTrackingNumber">
                <label class="confirmation-text delivery-charge-label">Tracking Number: </label>
                <div class="" formArrayName="tracking_numbers">
                    <div *ngFor="let trackingNumber of trackingNumbers.controls; let i = index">
                        <div
                            [formGroupName]="i" class="bigpost-delivery-rate custom-camera-icon">
                            <input formControlName="tracking_number" [ngClass]="{
                                            'is-invalid': trackingNumber.get('tracking_number').invalid && (trackingNumber.get('tracking_number').dirty || trackingNumber.get('tracking_number').touched),
                                            'is-valid': !trackingNumber.get('tracking_number').invalid && (trackingNumber.get('tracking_number').dirty || trackingNumber.get('tracking_number').touched),
                                            'tracking-number-custom-class': isDisplayCameraIcon
                                            }" [ngStyle]="{
                                            'margin-bottom': !isDisplayCameraIcon ? '0' : '20px'
                                            }" [maxlength]="trackingNumberMaxChars"
                                class="form-control tracking-number-custom-class" type="text" required
                                placeholder="Tracking number" (keyup)="onTrackingNumberKeyup($event, i)" />

                            <div (click)="checkForCamera(i)" class="custom-camera" *ngIf="isDisplayCameraIcon">
                                <i class='fas fa-camera'></i>
                            </div>
                            <span (click)="addTrackingNumber()">
                                <i class="fa fa-plus plus-icon" [tooltip]="'Add more tracking number'"
                                    *ngIf="isDisplayCameraIcon && i == 0"></i>
                            </span>
                            <i class="fa fa-close close-icon-costom" (click)="removeTrackingNumber(i)" [tooltip]="'Remove this tracking number'"
                                *ngIf="trackingNumbers.length > 1 && i > 0"></i>
                        </div>
                            <div class="invalid-feedback d-block" role="alert" *ngIf="trackingNumber.get('tracking_number').invalid && (trackingNumber.get('tracking_number').dirty || trackingNumber.get('tracking_number').touched || this.submitted)">
                                <div class="invalid-tracking-number" *ngIf="trackingNumber.get('tracking_number').hasError('required')">Enter tracking number.</div>
                            </div>
                    </div>
                </div>
            </div>

            <div class="form-field form-group">
              <label class="confirmation-text delivery-charge-label">Delivery Charge($):</label>
              <div class="bigpost-delivery-rate"
                   [ngClass]="{ 'is-invalid': sf.big_post_delivery_charge.invalid && (sf.big_post_delivery_charge.dirty || sf.big_post_delivery_charge.touched || submitted) }">
                <input formControlName="big_post_delivery_charge" [ngClass]="{
                                       'is-invalid': sf.big_post_delivery_charge.invalid && (sf.big_post_delivery_charge.dirty || sf.big_post_delivery_charge.touched || submitted),
                                       'is-valid': !sf.big_post_delivery_charge.invalid && (sf.big_post_delivery_charge.dirty || sf.big_post_delivery_charge.touched || submitted)
                                     }" class="form-control" type="text" required placeholder="Delivery charge"
                       (keypress)="checkDecimalDot($event)" appDecimalInput maxlength="8"
                       [value]="shippingPriceForm.get('big_post_delivery_charge').value"/>
                <span class="invalid-feedback" role="alert"
                      *ngIf="sf.big_post_delivery_charge.invalid && (sf.big_post_delivery_charge.dirty || sf.big_post_delivery_charge.touched || submitted)">
                                    <span
                                      *ngIf="sf.big_post_delivery_charge.errors!== null && sf.big_post_delivery_charge.errors.required">Enter delivery charge.</span>
                                </span>
              </div>
            </div>
            <div class="form-field form-group">
              <label class="confirmation-text delivery-charge-label">Packed By:</label>
              <div class="bigpost-delivery-rate"
                   [ngClass]="{ 'is-invalid': sf.packed_by.invalid && (sf.packed_by.dirty || sf.packed_by.touched ||submitted)}">
                <input formControlName="packed_by"
                       [ngClass]="{ 'is-invalid': sf.packed_by.invalid && (sf.packed_by.dirty || sf.packed_by.touched ||submitted), 'is-valid': !sf.packed_by.invalid && (sf.packed_by.dirty || sf.packed_by.touched ||submitted)}"
                       class="form-control" type="text" required placeholder="Packed by"/>
                <span class="invalid-feedback" role="alert"
                      *ngIf="sf.packed_by.invalid && (sf.packed_by.dirty || sf.packed_by.touched ||submitted)">
                                    <span *ngIf="sf.packed_by.errors!== null && sf.packed_by.errors.required">Enter packed by.</span>
                                </span>
              </div>
            </div>
          </div>
          <div class="modal-footer p-0">
            <button type="button" class="dark-bordered-btn" data-dismiss="modal" (click)="decline()">Cancel
            </button>
            <button type="submit" class="submit-btn-grey create-user-btn">Confirm</button>
          </div>
        </form>
      </div>
    </ng-container>

    <ng-container *ngIf="carrierRequired">
      <div class="delivery-charge-container ">
        <form [formGroup]="carrierForm" (ngSubmit)="onSubmitCarrier()"
              (keydown.enter)="$event.preventDefault()">
          <div class="email-selection-widget">
            <div class="free-order-address">
              <div class="form-field form-group">
                <label class="confirmation-text delivery-charge-label">Carrier:</label>
                <ng-select formControlName="carrier_id" class="form-control"
                           [ngClass]="{ 'is-invalid': (carrierForm.controls['carrier_id']?.invalid && (carrierForm.controls['carrier_id']?.dirty || carrierForm.controls['carrier_id']?.touched) || carrier_submitted) || cf.carrier_id?.errors?.apiError, 'is-valid' : !(carrierForm.controls['carrier_id']?.invalid)}"
                           [items]="carriers" [virtualScroll]="true" bindLabel="company_name" bindValue="id"
                           placeholder="Select Carrier" [clearable]="false">
                </ng-select>
                <span class="invalid-feedback" role="alert"
                      *ngIf="(carrierForm.controls['carrier_id'].invalid && carrierForm.controls['carrier_id'].touched || carrier_submitted)">
                                    <span *ngIf="cf.carrier_id.errors?.required">Select carrier.</span>
                                    <span
                                      *ngIf="cf.carrier_id.errors?.apiError">{{cf.carrier_id.errors?.apiError}}</span>
                                </span>
              </div>
              <div class="terms-conditions">
                <div class="accordion" id="accordionExample">
                  <div class="card-head" (click)="hideShowAddCarrierData()">
                    <h5 class="mb-0 collapsed" data-toggle="collapse" data-target="#collapseThree"
                        aria-expanded="false" aria-controls="collapseThree">Add New Carrier<i
                      class="fa fa-plus" aria-hidden="true"></i>
                    </h5>
                  </div>
                  <div id="collapseThree" class="collapse conditions-details"
                       aria-labelledby="headingThree" data-parent="#accordionExample">
                    <div class="card-body">
                      <div class="conditions-details-inner">
                        <div class="form-group">
                          <label>Company Name</label>
                          <input class="form-control" name="company_name" id="company_name"
                                 [ngClass]="{ 'is-invalid': (cf.company_name.invalid && cf.company_name.touched || carrier_submitted) || cf.company_name.errors?.apiError, 'is-valid' : !(carrierForm.controls['company_name'].invalid)}"
                                 formControlName="company_name" type="text"
                                 placeHolder="Enter Company Name">
                          <span class="invalid-feedback" role="alert"
                                *ngIf="(carrierForm.controls['company_name'].invalid && carrierForm.controls['company_name'].touched || carrier_submitted) || cf.company_name.errors?.apiError">
                                                        <span *ngIf="cf.company_name.errors?.required">Enter Company name.</span>
                                                        <span
                                                          *ngIf="cf.company_name.errors?.apiError">{{cf.company_name.errors?.apiError}}</span>
                                                    </span>
                        </div>
                        <div class="form-group">
                          <label>Contact Name</label>
                          <input class="form-control" name="contact_name" id="contact_name"
                                 [ngClass]="{ 'is-invalid': (carrierForm.controls['contact_name'].invalid && carrierForm.controls['contact_name'].touched || carrier_submitted) || cf.contact_name.errors?.apiError, 'is-valid' : !(carrierForm.controls['contact_name'].invalid)}"
                                 formControlName="contact_name" type="text"
                                 placeHolder="Enter Contact Name">
                          <span class="invalid-feedback" role="alert"
                                *ngIf="(carrierForm.controls['contact_name'].invalid && carrierForm.controls['contact_name'].touched || carrier_submitted) || cf.contact_name.errors?.apiError">
                                                        <span *ngIf="cf.contact_name.errors?.required">Enter contact name.</span>
                                                        <span
                                                          *ngIf="cf.contact_name.errors?.apiError">{{cf.contact_name.errors?.apiError}}</span>
                                                    </span>
                        </div>
                        <div class="form-group">
                          <label>Contact Mobile Number</label>
                          <input class="form-control" name="contact_mobile_number"
                                 id="contact_mobile_number"
                                 [ngClass]="{ 'is-invalid': (carrierForm.controls['contact_mobile_number'].invalid && carrierForm.controls['contact_mobile_number'].touched || carrier_submitted) || cf.contact_mobile_number.errors?.apiError, 'is-valid' : !(carrierForm.controls['contact_mobile_number'].invalid)}"
                                 formControlName="contact_mobile_number" type="text"
                                 placeHolder="Enter Contact Mobile Number" numbersOnly>
                          <span class="invalid-feedback" role="alert"
                                *ngIf="(carrierForm.controls['contact_mobile_number'].invalid && carrierForm.controls['contact_mobile_number'].touched || carrier_submitted) || cf.contact_mobile_number.errors?.apiError">
                                                        <span *ngIf="cf.contact_mobile_number.errors?.required">Enter contact mobile number.</span>
                                                        <span
                                                          *ngIf="cf.contact_mobile_number.errors?.maxlength || cf.contact_mobile_number.errors?.minlength">Enter valid contact mobile phone.</span>
                                                        <span
                                                          *ngIf="cf.contact_mobile_number.errors?.apiError">{{cf.contact_mobile_number.errors?.apiError}}</span>
                                                    </span>
                        </div>
                        <div class="form-group">
                          <label>Despatch Email</label>
                          <input class="form-control" name="dispatch_email"
                                 id="dispatch_email"
                                 [ngClass]="{ 'is-invalid': (carrierForm.controls['dispatch_email'].invalid && carrierForm.controls['dispatch_email'].touched || carrier_submitted) || cf.dispatch_email.errors?.apiError, 'is-valid' : !(carrierForm.controls['dispatch_email'].invalid)}"
                                 formControlName="dispatch_email" type="text"
                                 placeHolder="Enter Despatch Email">
                          <span class="invalid-feedback" role="alert"
                                *ngIf="(carrierForm.controls['dispatch_email'].invalid && carrierForm.controls['dispatch_email'].touched || carrier_submitted) || cf.dispatch_email.errors?.apiError">
                                                        <span *ngIf="cf.dispatch_email.errors?.required">Enter despatch email.</span>
                                                        <span
                                                          *ngIf="cf.dispatch_email.errors?.email || cf.dispatch_email.errors?.pattern">Enter a valid despatch email.</span>
                                                        <span
                                                          *ngIf="cf.dispatch_email.errors?.apiError">{{cf.dispatch_email.errors?.apiError}}</span>
                                                    </span>
                        </div>
                        <div class="form-group from-group-custom">
                          <label>Applicable Regions</label>
                          <ng-select formControlName="applicable_regions"
                                     dropdownPosition="bottom" class="form-control-custom"
                                     [ngClass]="{ 'is-invalid': (carrierForm.controls['applicable_regions']?.invalid && carrierForm.controls['applicable_regions']?.touched || carrier_submitted) || cf.applicable_regions?.errors?.apiError, 'is-valid' : !(carrierForm.controls['applicable_regions']?.invalid)}"
                                     [items]="regions" bindLabel="name" bindValue="id"
                                     [multiple]="true" placeholder="Select Applicable Regions"
                                     [closeOnSelect]="false">
                            <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                         let-index="index">
                              <div class="custom-control custom-checkbox">
                                <input id="item-{{index}}" type="checkbox"
                                       [ngModel]="item$.selected"
                                       [ngModelOptions]="{standalone: true}"
                                       class="custom-control-input"/>
                                <label
                                  class="custom-control-label">{{item.name}}</label>
                              </div>
                            </ng-template>
                          </ng-select>

                          <span class="invalid-feedback" role="alert"
                                *ngIf="(carrierForm.controls['applicable_regions'].invalid && carrierForm.controls['applicable_regions'].touched || carrier_submitted) || cf.applicable_regions.errors?.apiError">
                                                        <span *ngIf="cf.applicable_regions.errors?.required">Select applicable regions.</span>
                                                        <span
                                                          *ngIf="cf.applicable_regions.errors?.apiError">{{cf.applicable_regions.errors?.apiError}}</span>
                                                    </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer p-0">
              <button type="button" class="dark-bordered-btn" data-dismiss="modal"
                      (click)="decline()">Cancel
              </button>
              <button type="submit" class="submit-btn-grey create-user-btn">Confirm</button>
            </div>
          </div>
        </form>
      </div>
    </ng-container>

    <ng-container *ngIf="shipmentReferenceRequired">
      <div class="delivery-charge-container ">
        <form [formGroup]="shippingReferenceForm" (ngSubmit)="onSubmitShipmentReference()"
              (keydown.enter)="$event.preventDefault()">
          <div class="email-selection-widget">
            <div class="free-order-address">
              <div class="form-group">
                <label class="grey-label">GPSM Shipment Reference</label>
                <input class="form-control"
                       [ngClass]="{ 'is-invalid': (shp.shipping_reference.invalid && shp.shipping_reference.touched || shipment_reference_submitted) || shp.shipping_reference.errors?.apiError, 'is-valid' : !(shippingReferenceForm.controls['shipping_reference'].invalid)}"
                       formControlName="shipping_reference" type="text"
                       placeHolder="Enter GPSM shipment reference"
                       (keypress)="keyPressAlphaNumeric($event)" [maxlength]="shipmentReferenceMaxChars">
                <span class="invalid-feedback" role="alert"
                      *ngIf="(shippingReferenceForm.controls['shipping_reference'].invalid && shippingReferenceForm.controls['shipping_reference'].touched || shipment_reference_submitted) || shp.shipping_reference.errors?.apiError">
                                    <span *ngIf="shp.shipping_reference.errors?.required">Enter GPSM shipment reference.</span>
                                    <span
                                      *ngIf="shp.shipping_reference.errors?.apiError">{{shp.shipping_reference.errors?.apiError}}</span>
                                </span>
                <div class="email-selection-widget custom-label-checkbox">
                  <input type="checkbox" data-md-icheck
                         (change)="enableDisableShipmentReference($event)"
                         formControlName="is_domestic_stock_transfer"/>
                  <label class="checkbox-custom">Domestic Stock Transfer</label>
                </div>
              </div>
            </div>
            <div class="modal-footer p-0">
              <button type="button" class="dark-bordered-btn" data-dismiss="modal"
                      (click)="decline()">Cancel
              </button>
              <button type="submit" class="submit-btn-grey create-user-btn">Confirm</button>
            </div>
          </div>
        </form>
      </div>
    </ng-container>

    <ng-container *ngIf="enableDisableGPSMSyncRequired">
      <div class="delivery-charge-container ">
        <div class="email-selection-widget">
          <div class="free-order-address gpsm-sync-container">
            <div class="custom-label-checkbox">
              <input for="checkbox-custom" type="checkbox" data-md-icheck
                     [checked]="enableDisableGPSMSyncCheckbox" class="form-check-input"
                     (change)="changeValue($event)"/>
              <label class="checkbox-custom">Disabling GPSM Sync</label>
              <span
                [tooltip]="'In the event of reverting the order status, the GPSM sync will be disabled specifically for this order.'"
                [adaptivePosition]="false" container="'body'"><img
                src="{{s3BucketImageURL}}/info-icon.svg" alt="Info Icon"
                class="cursor-pointer"></span>
            </div>
          </div>
          <div class="modal-footer p-0">
            <button type="button" class="dark-bordered-btn" data-dismiss="modal" (click)="decline()">Cancel
            </button>
            <button type="button" class="submit-btn-grey create-user-btn"
                    (click)="onSubmitEnableDisableGPSMSync()">Confirm
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
<!-- Modal footer -->
<div class="modal-footer"
     *ngIf="!(deliveryChargeRequired || carrierRequired || shipmentReferenceRequired || enableDisableGPSMSyncRequired ||this.currentStatusId === constants.SAMPLE_PACKAGES_STATUS_ID)">
  <button type="button" class="dark-bordered-btn" data-dismiss="modal" (click)="decline()">{{ requestType === constants.SAMPLE_REQUEST_CLOSE ? 'No' : 'Cancel' }}</button>
  <button type="button" class="submit-btn-grey delete-confirmed" (click)="confirm()">{{ requestType === constants.SAMPLE_REQUEST_CLOSE ? 'Yes' : 'Confirm' }}</button>
</div>
